import { createGlobalStyle } from 'styled-components'

const Typography = createGlobalStyle`

  /* -------------------- Typography -------------------- */

  * {
    box-sizing: border-box;
    -webkit-appearance: none;
    outline: none;
    -webkit-font-smoothing: antialiased;
  }


  input[type="search"]::-webkit-search-decoration,
  input[type="search"]::-webkit-search-cancel-button,
  input[type="search"]::-webkit-search-results-button,
  input[type="search"]::-webkit-search-results-decoration {
    -webkit-appearance: none;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* -------------------- Firefox -------------------- */

  input[type=number] {
    -moz-appearance: textfield;
  }

  input:-internal-autofill-selected {
    background-color: transparent !important;
    box-shadow: inset 1000px 1000px #fff;
  }

  input:focus::placeholder {
    color: transparent;
  }

  input {
    outline: none;
  }

  input:-webkit-autofill {
    -webkit-text-fill-color: var(--textColor) !important;
    -webkit-box-shadow: inset 0 0 0 50px var(--textColor) !important;
  }

  /* -------------------- Change autocomplete styles in WebKit -------------------- */
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  textarea:-webkit-autofill,
  textarea:-webkit-autofill:hover,
  textarea:-webkit-autofill:focus,
  select:-webkit-autofill,
  select:-webkit-autofill:hover,
  select:-webkit-autofill:focus {
    border: 2px solid black;
    -webkit-text-fill-color: black;
    color: white;
    background-color: transparent;
    -webkit-box-shadow: 0 0 0 1000px transparent inset;
    transition: background-color 5000s ease-in-out 0s;
  }

  /* -------------------- Change the white to any color ;) -------------------- */
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 30px transparent inset !important;
  }

  @-webkit-keyframes autofill {
    to {
      background: transparent;
    }
  }

  a {
    text-decoration: none;
    color: unset;
  }

  //! Text styles

  .uppercase {
    text-transform: uppercase;
  }

  .lowercase {
    text-transform: lowercase;
  }

  .capitalize {
    text-transform: capitalize;
  }

  .underline {
    text-decoration: underline;
  }

  .lineThrough {
    text-decoration: line-through;
  }

  //! Fonts

  .terminaBold {
    font-family: terminaBold;
  }

  .terminaSemiBold {
    font-family: terminaSemiBold;
  }

  .terminaMedium {
    font-family: terminaMedium;
  }

  .terminaRegular {
    font-family: terminaRegular;
  }

  .maisonMedium {
    font-family: maisonMedium;
  }

  .maisonSemiBold {
    font-family: maisonSemiBold;
  }

  //! Colors

  .black {
    color: var(--black);
  }

  .grey {
    color: var(--grey);
  }

  .white {
    color: var(--white);
  }

  .green {
    color: var(--green);
  }

  .errorRed {
    color: var(--red);
  }

  .darkCream {
    color: var(--darkCream);
  }

  .cream {
    color: var(--cream);
  }

  .orange {
    color: var(--orange);
  }

  .dirtGreen {
    color: var(--dirtGreen);
  }

  //! Font Sizes

  .big {
    font-size: var(--big);
    margin: 0;
    line-height: var(--lineHeightSuperMin);
    font-weight: unset;
  }

  .h1,
  h1 {
    font-size: var(--h1);
    margin: 0;
    line-height: var(--lineHeightMin);
    font-weight: unset;
  }

  .h2,
  h2 {
    font-size: var(--h2);
    margin: 0;
    line-height: var(--lineHeightMin);
    font-weight: unset;
  }

  .h3,
  h3 {
    font-size: var(--h3);
    margin: 0;
    line-height: var(--lineHeightMin);
    font-weight: unset;
  }

  .h4,
  h4 {
    font-size: var(--h4);
    margin: 0;
    line-height: var(--lineHeightMin);
    font-weight: unset;
  }

  .h5,
  h5 {
    font-size: var(--h5);
    margin: 0;
    line-height: var(--lineHeightMin);
    font-weight: unset;
  }

  .h6,
  h6 {
    font-size: var(--h6);
    margin: 0;
    line-height: var(--lineHeightMin);
    font-weight: unset;
  }

  .h7 {
    font-size: var(--h7);
    margin: 0;
    line-height: var(--lineHeightMin);
    font-weight: unset;
  }

  .h8 {
    font-size: var(--h8);
    margin: 0;
    line-height: var(--lineHeightMin);
    font-weight: unset;
  }

  .h9 {
    font-size: var(--h9);
    margin: 0;
    line-height: var(--lineHeightMax);
    font-weight: unset;
  }

  .h10 {
    font-size: var(--h10);
    margin: 0;
    line-height: var(--lineHeightMax);
    font-weight: unset;
  }

  .p, p {
    font-size: var(--p);
    margin: 0;
    line-height: var(--lineHeightMax);
    font-weight: unset;
  }
.mini {
    font-size: var(--mini);
    margin: 0;
    line-height: var(--lineHeightMax);
    font-weight: unset;
}
`

export default Typography
